import { render, staticRenderFns } from "./startSprint.vue?vue&type=template&id=8376aa38&scoped=true&"
import script from "./startSprint.vue?vue&type=script&lang=js&"
export * from "./startSprint.vue?vue&type=script&lang=js&"
import style0 from "./startSprint.vue?vue&type=style&index=0&id=8376aa38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8376aa38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8376aa38')) {
      api.createRecord('8376aa38', component.options)
    } else {
      api.reload('8376aa38', component.options)
    }
    module.hot.accept("./startSprint.vue?vue&type=template&id=8376aa38&scoped=true&", function () {
      api.rerender('8376aa38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/products/roadmap/startSprint.vue"
export default component.exports